import { PhoneIcon,MailIcon, LocationMarkerIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'

export default function Footer(){
    const anio = new Date().getFullYear();

    return (
        <>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 py-8 bg-regal-blue'>
                <div className="md:flex justify-center md:flex items-center">
                    <div className="bg-auto px-4">
                        <div className="bg-logo-light w-full h-full">
                            <Link to='/'><img src='/images/logo.png' alt='logo Viajes Manguen' className='w-auto h-20' ></img></Link>
                        </div>
                    </div>
                </div>
                <div className="md:flex justify-center md:flex items-center">
                    <div className="bg-auto px-4 py-10 grid grid-cols-2 gap-4">
                        <img src='/images/formas-de-pago.png' alt='Formas de pago Viajes Manguen' className='w-full h-auto'/>
                        <img src='/images/MSS.png' alt='Formas de pago Viajes Manguen' className='w-1/2 h-auto'/>
                    </div>
                </div>
                <div className="md:flex justify-center md:flex items-center">
                    <div className="flex flex-col space-y-4 px-4 text-white">
                        <div className='flex flex-row'><LocationMarkerIcon className="h-6 w-6 text-green-500 basis-1/6"/><p className='basis-1/2'>Fernando Iglesias Calderón # 93-6, Colonia Jardín Balbuena, C.P. 15900, Alcaldía Venustiano Carranza, Ciudad de México.</p></div>
                        <div className='flex flex-row'><PhoneIcon className="h-6 w-6 text-green-500 basis-1/6"/><a  href='tel:5555521118' className='basis-1/2'>(55) 5552-1118 <br/>(55) 2736-4548</a></div>
                        <div className='flex flex-row'><MailIcon className="h-6 w-6 text-green-500 basis-1/6"/><a href='mailto:viajesmanguen.gmail.com' className='basis-1/2'>viajesmanguen.gmail.com</a></div>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center h-10 px-4 text-xs bg-regal-blue text-white'>
                <p className='mt-5'>Copyright © {anio} Powered by Macc Systems.</p>
            </div>
        </>
    );
};